import React from "react";

/** When true, feed post captions skip filled “chip” backgrounds (e.g. master template search). */
export const CaptionFlatBackgroundContext = React.createContext(false);

export function CaptionFlatBackgroundProvider({
  value,
  children,
}: {
  value: boolean;
  children: React.ReactNode;
}) {
  return (
    <CaptionFlatBackgroundContext.Provider value={value}>
      {children}
    </CaptionFlatBackgroundContext.Provider>
  );
}
